import { uploadAsset } from './upload-assets'

type UploadMusicAssetsParams = {
  artworkFile?: File
  audioFile?: File
  slugSource: string
}

export async function uploadMusicAssets({
  artworkFile,
  audioFile,
  slugSource,
}: UploadMusicAssetsParams) {
  const [privateArtworkFiles, publicArtworkFiles, audioFiles] =
    await Promise.all([
      artworkFile
        ? uploadAsset({
            file: artworkFile,
            folder: 'musics',
            title: slugSource,
            visibility: 'private',
          })
        : Promise.resolve([]),
      artworkFile
        ? uploadAsset({
            file: artworkFile,
            folder: 'musics',
            title: slugSource,
            visibility: 'public',
          })
        : Promise.resolve([]),
      audioFile
        ? uploadAsset({
            file: audioFile,
            folder: 'musics',
            title: slugSource,
            visibility: 'private',
          })
        : Promise.resolve([]),
    ])

  return {
    privateArtworkFile: privateArtworkFiles[0],
    publicArtworkFile: publicArtworkFiles[0],
    audioFile: audioFiles[0],
  }
}
